import {Injectable} from '@angular/core';
import {FraudReportsResponse} from '@npck/af-frontend-api';
import {RouterService} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {initialTableEvent, TableEvent} from '../components/full-table/full-table.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class FraudReportsFilterHolderService {
    private tableHolder = this.initialState();

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.ANALYTICS)) {
                    this.clear();
                }
            });
    }

    storeTableState(tableEvent: TableEvent): FraudReportsTableInfo {
        this.tableHolder = {...this.tableHolder, tableEvent};
        return this.tableHolder;
    }

    storeResponse(response: FraudReportsResponse): void {
        this.tableHolder = {...this.tableHolder, response, cachedTime: dayjs()};
    }

    getState(): FraudReportsTableInfo {
        return this.tableHolder;
    }

    clear(): void {
        this.tableHolder = this.initialState();
    }

    private initialState(): FraudReportsTableInfo {
        return <FraudReportsTableInfo>{
            tableEvent: {
                ...initialTableEvent,
                filter: {},
            },
        };
    }
}

export interface FraudReportsTableInfo {
    tableEvent: TableEvent;
    response?: FraudReportsResponse;
    cachedTime: dayjs.Dayjs;
}
